var map = {
	"./2008.wmv": 197,
	"./2009.wmv": 198,
	"./2010.wmv": 199,
	"./2011.avi": 200,
	"./2012.avi": 201,
	"./2013.wmv": 202,
	"./2014.wmv": 203,
	"./2015.wmv": 204,
	"./2017_vid.mp4": 205,
	"./2018_vid.mp4": 206,
	"./2019.mp4": 207,
	"./2019HD.mp4": 208,
	"./2020.mp4": 209,
	"./2021.mp4": 210,
	"./2022.mp4": 211,
	"./2023.mp4": 212,
	"./2024.mp4": 213,
	"./2025.mp4": 214,
	"./2026.mp4": 215,
	"./taj01.mp4": 216,
	"./taj02.mp4": 217,
	"./tuiga1.mp4": 218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;